
export const PermissionList = {
  Accounting_Create:"Permissions.Accounting.Create",
Accounting_Delete:"Permissions.Accounting.Delete",
Accounting_Search:"Permissions.Accounting.Search",
Accounting_Update:"Permissions.Accounting.Update",
Accounting_View:"Permissions.Accounting.View",
Distribution_Create:"Permissions.Distribution.Create",
Distribution_Delete:"Permissions.Distribution.Delete",
Distribution_Search:"Permissions.Distribution.Search",
Distribution_Update:"Permissions.Distribution.Update",
Distribution_View:"Permissions.Distribution.View",
ECommerce_Create:"Permissions.ECommerce.Create",
ECommerce_Delete:"Permissions.ECommerce.Delete",
ECommerce_Search:"Permissions.ECommerce.Search",
ECommerce_Update:"Permissions.ECommerce.Update",
ECommerce_View:"Permissions.ECommerce.View",
ELearning_Create:"Permissions.ELearning.Create",
ELearning_Delete:"Permissions.ELearning.Delete",
ELearning_Search:"Permissions.ELearning.Search",
ELearning_Update:"Permissions.ELearning.Update",
ELearning_View:"Permissions.ELearning.View",
FinancialAccess_Create:"Permissions.FinancialAccess.Create",
FinancialAccess_Delete:"Permissions.FinancialAccess.Delete",
FinancialAccess_Search:"Permissions.FinancialAccess.Search",
FinancialAccess_Update:"Permissions.FinancialAccess.Update",
FinancialAccess_View:"Permissions.FinancialAccess.View",
HRMS_Create:"Permissions.HRMS.Create",
HRMS_Delete:"Permissions.HRMS.Delete",
HRMS_Search:"Permissions.HRMS.Search",
HRMS_Update:"Permissions.HRMS.Update",
HRMS_View:"Permissions.HRMS.View",
HRMS_Finance:"Permissions.HRMS.Finance",
Inventory_Create:"Permissions.Inventory.Create",
Inventory_Delete:"Permissions.Inventory.Delete",
Inventory_Search:"Permissions.Inventory.Search",
Inventory_Update:"Permissions.Inventory.Update",
Inventory_Finance: "Permissions.Inventory.Finance",
Inventory_View:"Permissions.Inventory.View",
Marketing_Create:"Permissions.Marketing.Create",
Marketing_Delete:"Permissions.Marketing.Delete",
Marketing_Search:"Permissions.Marketing.Search",
Marketing_Update:"Permissions.Marketing.Update",
Marketing_View:"Permissions.Marketing.View",
Marketing_Finance:"Permissions.Marketing.Finance",
MarketingFacebook_Create:"Permissions.MarketingFacebook.Create",
MarketingFacebook_Delete:"Permissions.MarketingFacebook.Delete",
MarketingFacebook_Update:"Permissions.MarketingFacebook.Update",
MarketingFacebook_View:"Permissions.MarketingFacebook.View",
PerformanceRecord_Create:"Permissions.PerformanceRecord.Create",
PerformanceRecord_Delete:"Permissions.PerformanceRecord.Delete",
PerformanceRecord_Update:"Permissions.PerformanceRecord.Update",
PerformanceRecord_View:"Permissions.PerformanceRecord.View",
Production_Create:"Permissions.Production.Create",
Production_Delete:"Permissions.Production.Delete",
Production_Search:"Permissions.Production.Search",
Production_Update:"Permissions.Production.Update",
Production_View:"Permissions.Production.View",
Production_Finance:"Permissions.Production.Finance",
ProjectManagement_Create:"Permissions.ProjectManagement.Create",
ProjectManagement_Delete:"Permissions.ProjectManagement.Delete",
ProjectManagement_Search:"Permissions.ProjectManagement.Search",
ProjectManagement_Update:"Permissions.ProjectManagement.Update",
ProjectManagement_View:"Permissions.ProjectManagement.View",
Reporting_Create:"Permissions.Reporting.Create",
Reporting_Delete:"Permissions.Reporting.Delete",
Reporting_Search:"Permissions.Reporting.Search",
Reporting_Update:"Permissions.Reporting.Update",
Reporting_View:"Permissions.Reporting.View",
RoleClaims_Update:"Permissions.RoleClaims.Update",
RoleClaims_View:"Permissions.RoleClaims.View",
Roles_Create:"Permissions.Roles.Create",
Roles_Delete:"Permissions.Roles.Delete",
Roles_Update:"Permissions.Roles.Update",
Roles_View:"Permissions.Roles.View",
Sales_Create:"Permissions.Sales.Create",
Sales_Delete:"Permissions.Sales.Delete",
Sales_Search:"Permissions.Sales.Search",
Sales_Update:"Permissions.Sales.Update",
Sales_View:"Permissions.Sales.View",
ServiceManagement_Create:"Permissions.ServiceManagement.Create",
ServiceManagement_Delete:"Permissions.ServiceManagement.Delete",
ServiceManagement_Search:"Permissions.ServiceManagement.Search",
ServiceManagement_Update:"Permissions.ServiceManagement.Update",
ServiceManagement_View:"Permissions.ServiceManagement.View",
ServiceManagement_Finance:"Permissions.ServiceManagement.Finance",
Support_Create:"Permissions.Support.Create",
Support_Delete:"Permissions.Support.Delete",
Support_Search:"Permissions.Support.Search",
Support_Update:"Permissions.Support.Update",
Support_View:"Permissions.Support.View",
Tenants_Create:"Permissions.Tenants.Create",
Tenants_Update:"Permissions.Tenants.Update",
Tenants_View:"Permissions.Tenants.View",
UserRoles_Update:"Permissions.UserRoles.Update",
UserRoles_View:"Permissions.UserRoles.View",
Users_Create:"Permissions.Users.Create",
Users_Delete:"Permissions.Users.Delete",
Users_Export:"Permissions.Users.Export",
Users_Search:"Permissions.Users.Search",
Users_Update:"Permissions.Users.Update",
Users_View:"Permissions.Users.View",
WebsiteBuilder_Create:"Permissions.WebsiteBuilder.Create",
WebsiteBuilder_Delete:"Permissions.WebsiteBuilder.Delete",
WebsiteBuilder_Search:"Permissions.WebsiteBuilder.Search",
WebsiteBuilder_Update:"Permissions.WebsiteBuilder.Update",
WebsiteBuilder_View:"Permissions.WebsiteBuilder.View",
}

//#region Common
export const CountryList = [{ value: "Mauritius", text: "Mauritius" }];

export const FullCountryList = [
  { value: "Afghanistan", text: "Afghanistan" },
  { value: "Albania", text: "Albania" },
  { value: "Algeria", text: "Algeria" },
  { value: "Andorra", text: "Andorra" },
  { value: "Angola", text: "Angola" },
  { value: "Antigua and Barbuda", text: "Antigua and Barbuda" },
  { value: "Argentina", text: "Argentina" },
  { value: "Armenia", text: "Armenia" },
  { value: "Australia", text: "Australia" },
  { value: "Austria", text: "Austria" },
  { value: "Azerbaijan", text: "Azerbaijan" },
  { value: "Bahamas", text: "Bahamas" },
  { value: "Bahrain", text: "Bahrain" },
  { value: "Bangladesh", text: "Bangladesh" },
  { value: "Barbados", text: "Barbados" },
  { value: "Belarus", text: "Belarus" },
  { value: "Belgium", text: "Belgium" },
  { value: "Belize", text: "Belize" },
  { value: "Benin", text: "Benin" },
  { value: "Bhutan", text: "Bhutan" },
  { value: "Bolivia", text: "Bolivia" },
  { value: "Bosnia and Herzegovina", text: "Bosnia and Herzegovina" },
  { value: "Botswana", text: "Botswana" },
  { value: "Brazil", text: "Brazil" },
  { value: "Brunei", text: "Brunei" },
  { value: "Bulgaria", text: "Bulgaria" },
  { value: "Burkina Faso", text: "Burkina Faso" },
  { value: "Burundi", text: "Burundi" },
  { value: "Cambodia", text: "Cambodia" },
  { value: "Cameroon", text: "Cameroon" },
  { value: "Canada", text: "Canada" },
  { value: "Cape Verde", text: "Cape Verde" },
  { value: "Central African Republic", text: "Central African Republic" },
  { value: "Chad", text: "Chad" },
  { value: "Chile", text: "Chile" },
  { value: "China", text: "China" },
  { value: "Colombia", text: "Colombia" },
  { value: "Comoros", text: "Comoros" },
  { value: "Congo, Democratic Republic of the", text: "Congo, Democratic Republic of the" },
  { value: "Congo, Republic of the", text: "Congo, Republic of the" },
  { value: "Costa Rica", text: "Costa Rica" },
  { value: "Croatia", text: "Croatia" },
  { value: "Cuba", text: "Cuba" },
  { value: "Cyprus", text: "Cyprus" },
  { value: "Czech Republic", text: "Czech Republic" },
  { value: "Denmark", text: "Denmark" },
  { value: "Djibouti", text: "Djibouti" },
  { value: "Dominica", text: "Dominica" },
  { value: "Dominican Republic", text: "Dominican Republic" },
  { value: "Ecuador", text: "Ecuador" },
  { value: "Egypt", text: "Egypt" },
  { value: "El Salvador", text: "El Salvador" },
  { value: "Equatorial Guinea", text: "Equatorial Guinea" },
  { value: "Eritrea", text: "Eritrea" },
  { value: "Estonia", text: "Estonia" },
  { value: "Eswatini", text: "Eswatini" },
  { value: "Ethiopia", text: "Ethiopia" },
  { value: "Fiji", text: "Fiji" },
  { value: "Finland", text: "Finland" },
  { value: "France", text: "France" },
  { value: "Gabon", text: "Gabon" },
  { value: "Gambia", text: "Gambia" },
  { value: "Georgia", text: "Georgia" },
  { value: "Germany", text: "Germany" },
  { value: "Ghana", text: "Ghana" },
  { value: "Greece", text: "Greece" },
  { value: "Grenada", text: "Grenada" },
  { value: "Guatemala", text: "Guatemala" },
  { value: "Guinea", text: "Guinea" },
  { value: "Guinea-Bissau", text: "Guinea-Bissau" },
  { value: "Guyana", text: "Guyana" },
  { value: "Haiti", text: "Haiti" },
  { value: "Honduras", text: "Honduras" },
  { value: "Hungary", text: "Hungary" },
  { value: "Iceland", text: "Iceland" },
  { value: "India", text: "India" },
  { value: "Indonesia", text: "Indonesia" },
  { value: "Iran", text: "Iran" },
  { value: "Iraq", text: "Iraq" },
  { value: "Ireland", text: "Ireland" },
  { value: "Israel", text: "Israel" },
  { value: "Italy", text: "Italy" },
  { value: "Jamaica", text: "Jamaica" },
  { value: "Japan", text: "Japan" },
  { value: "Jordan", text: "Jordan" },
  { value: "Kazakhstan", text: "Kazakhstan" },
  { value: "Kenya", text: "Kenya" },
  { value: "Kiribati", text: "Kiribati" },
  { value: "Korea, North", text: "Korea, North" },
  { value: "Korea, South", text: "Korea, South" },
  { value: "Kuwait", text: "Kuwait" },
  { value: "Kyrgyzstan", text: "Kyrgyzstan" },
  { value: "Laos", text: "Laos" },
  { value: "Latvia", text: "Latvia" },
  { value: "Lebanon", text: "Lebanon" },
  { value: "Lesotho", text: "Lesotho" },
  { value: "Liberia", text: "Liberia" },
  { value: "Libya", text: "Libya" },
  { value: "Liechtenstein", text: "Liechtenstein" },
  { value: "Lithuania", text: "Lithuania" },
  { value: "Luxembourg", text: "Luxembourg" },
  { value: "Madagascar", text: "Madagascar" },
  { value: "Malawi", text: "Malawi" },
  { value: "Malaysia", text: "Malaysia" },
  { value: "Maldives", text: "Maldives" },
  { value: "Mali", text: "Mali" },
  { value: "Malta", text: "Malta" },
  { value: "Marshall Islands", text: "Marshall Islands" },
  { value: "Mauritania", text: "Mauritania" },
  { value: "Mauritius", text: "Mauritius" },
  { value: "Mexico", text: "Mexico" },
  { value: "Micronesia", text: "Micronesia" },
  { value: "Moldova", text: "Moldova" },
  { value: "Monaco", text: "Monaco" },
  { value: "Mongolia", text: "Mongolia" },
  { value: "Montenegro", text: "Montenegro" },
  { value: "Morocco", text: "Morocco" },
  { value: "Mozambique", text: "Mozambique" },
  { value: "Myanmar", text: "Myanmar" },
  { value: "Namibia", text: "Namibia" },
  { value: "Nauru", text: "Nauru" },
  { value: "Nepal", text: "Nepal" },
  { value: "Netherlands", text: "Netherlands" },
  { value: "New Zealand", text: "New Zealand" },
  { value: "Nicaragua", text: "Nicaragua" },
  { value: "Niger", text: "Niger" },
  { value: "Nigeria", text: "Nigeria" },
  { value: "North Macedonia", text: "North Macedonia" },
  { value: "Norway", text: "Norway" },
  { value: "Oman", text: "Oman" },
  { value: "Pakistan", text: "Pakistan" },
  { value: "Palau", text: "Palau" },
  { value: "Panama", text: "Panama" },
  { value: "Papua New Guinea", text: "Papua New Guinea" },
  { value: "Paraguay", text: "Paraguay" },
  { value: "Peru", text: "Peru" },
  { value: "Philippines", text: "Philippines" },
  { value: "Poland", text: "Poland" },
  { value: "Portugal", text: "Portugal" },
  { value: "Qatar", text: "Qatar" },
  { value: "Romania", text: "Romania" },
  { value: "Russia", text: "Russia" },
  { value: "Rwanda", text: "Rwanda" },
  { value: "Saint Kitts and Nevis", text: "Saint Kitts and Nevis" },
  { value: "Saint Lucia", text: "Saint Lucia" },
  { value: "Saint Vincent and the Grenadines", text: "Saint Vincent and the Grenadines" },
  { value: "Samoa", text: "Samoa" },
  { value: "San Marino", text: "San Marino" },
  { value: "Sao Tome and Principe", text: "Sao Tome and Principe" },
  { value: "Saudi Arabia", text: "Saudi Arabia" },
  { value: "Senegal", text: "Senegal" },
  { value: "Serbia", text: "Serbia" },
  { value: "Seychelles", text: "Seychelles" },
  { value: "Sierra Leone", text: "Sierra Leone" },
  { value: "Singapore", text: "Singapore" },
  { value: "Slovakia", text: "Slovakia" },
  { value: "Slovenia", text: "Slovenia" },
  { value: "Solomon Islands", text: "Solomon Islands" },
  { value: "Somalia", text: "Somalia" },
  { value: "South Africa", text: "South Africa" },
  { value: "South Korea", text: "South Korea" },
  { value: "South Sudan", text: "South Sudan" },
  { value: "Spain", text: "Spain" },
  { value: "Sri Lanka", text: "Sri Lanka" },
  { value: "Sudan", text: "Sudan" },
  { value: "Suriname", text: "Suriname" },
  { value: "Sweden", text: "Sweden" },
  { value: "Switzerland", text: "Switzerland" },
  { value: "Syria", text: "Syria" },
  { value: "Taiwan", text: "Taiwan" },
  { value: "Tajikistan", text: "Tajikistan" },
  { value: "Tanzania", text: "Tanzania" },
  { value: "Thailand", text: "Thailand" },
  { value: "Timor-Leste", text: "Timor-Leste" },
  { value: "Togo", text: "Togo" },
  { value: "Tonga", text: "Tonga" },
  { value: "Trinidad and Tobago", text: "Trinidad and Tobago" },
  { value: "Tunisia", text: "Tunisia" },
  { value: "Turkey", text: "Turkey" },
  { value: "Turkmenistan", text: "Turkmenistan" },
  { value: "Tuvalu", text: "Tuvalu" },
  { value: "Uganda", text: "Uganda" },
  { value: "Ukraine", text: "Ukraine" },
  { value: "United Arab Emirates", text: "United Arab Emirates" },
  { value: "United Kingdom", text: "United Kingdom" },
  { value: "United States", text: "United States" },
  { value: "Uruguay", text: "Uruguay" },
  { value: "Uzbekistan", text: "Uzbekistan" },
  { value: "Vanuatu", text: "Vanuatu" },
  { value: "Vatican City", text: "Vatican City" },
  { value: "Venezuela", text: "Venezuela" },
  { value: "Vietnam", text: "Vietnam" },
  { value: "Yemen", text: "Yemen" },
  { value: "Zambia", text: "Zambia" },
  { value: "Zimbabwe", text: "Zimbabwe" }
];


export const GenderList = [
  { value: "Male", text: "Male" },
  { value: "Female", text: "Female" },
];

export const ModuleReferenceList = {
  Product: "Product",
  EquipmentDiary: "EquipmentDiary",
  JobCard: "JobCard",
  Project: "Project",
  LeadClient: "LeadClient",
  RawMaterial: "RawMaterial",
  Supplier: "Supplier",
};

export const CurrencySymbols = {
  USD: "$",
  EUR: "€",
  JPY: "¥",
  GBP: "£",
  AUD: "A$",
  CAD: "C$",
  CHF: "CHF",
  CNY: "¥",
  SEK: "kr",
  NZD: "NZ$",
  MXN: "$",
  SGD: "S$",
  HKD: "HK$",
  NOK: "kr",
  KRW: "₩",
  TRY: "₺",
  RUB: "₽",
  INR: "₹",
  BRL: "R$",
  ZAR: "R",
  PHP: "₱",
  IDR: "Rp",
  MYR: "RM",
  THB: "฿",
  TWD: "NT$",
  DKK: "kr",
  PLN: "zł",
  SAR: "ر.س",
  AED: "د.إ",
  ILS: "₪",
  MUR: "Rs",
};

//#endregion

//#region HRMS

export const EmploymentStatus = [
  { value: "EMPLOYED", text: "Employed" },
  { value: "RESIGNED", text: "Resigned" },
  { value: "TERMINATED", text: "Terminated" },
];

export const EmployeeDocumentType = [
  { value: "Contract", text: "Contract" },
  { value: "CV", text: "CV" },
  { value: "POA", text: "POA" },
  { value: "POI", text: "POI" },
  { value: "PERMIT", text: "Permit" },
  { value: "Performance", text: "Performance Appraisal" },
];

export const EmployeeDocumentStatus = [
  { value: "0", text: "Pending" },
  { value: "1", text: "Approved" },
  { value: "2", text: "Rejected" },
];

//#endregion

//#region Accounting

export const AccountType = [
  { text: "Current Asset", value: "CurrentAsset" },
  { text: "Fixed Asset", value: "FixedAsset" },
  { text: "Equity", value: "Equity" },
  { text: "Current Liability", value: "CurrentLiability" },
  { text: "Non Current Liability", value: "NonCurrentLiability" },
  { text: "Other Income", value: "OtherIncome" },
  { text: "Expense", value: "Expense" },
  { text: "Sales", value: "Sales" },
  { text: "Bank", value: "Bank" },
];

export const AccountCategory = [
  { text: "Assets", value: "Assets" },
  { text: "Liabilities", value: "Liabilities" },
  { text: "Equity", value: "Equity" },
  { text: "Revenue", value: "Revenue" },
  { text: "Expenses", value: "Expenses" },
  { text: "Bank", value: "Bank" },
];

//#endregion

//#region Timesheet

export const TimesheetStatus = [
  { text: "Pending", value: "PENDING" },
  { text: "Approved", value: "APPROVED" },
  { text: "Rejected", value: "REJECTED" },
//   { text: "Done", value: "DONE" },
//   { text: "Cancelled", value: "CANCELLED" },
];

export const TimesheetModules = [
  {text: "Accounting", value: "Accounting"},
  {text: "HRMS", value: "HRMS"},
  {text: "JobCard", value: "JobCard"},
  {text: "Project", value: "Project"},
  {text: "Service Order", value: "ServiceOrder"},
]

//#endregion

//#region Project Management
export const ProjectStatus =
[
  { value: "NOTSTARTED", text: "Not Started" },
  { value: "REMOVED", text: "Removed" },
  { value: "APPROVED", text: "Approved" },
  { value: "NEW", text: "New" },
  { value: "INPROGRESS", text: "In Progress" },
  { value: "ONHOLD", text: "On Hold" },
  { value: "COMPLETED", text: "Completed" },
];

export const ProjectProgress = 
[
  { value: "NOTSPECIFIED", text: "Not Specified" },
  { value: "ONTRACK", text: "On Track" },
  { value: "DELAYED", text: "On Hold" },
]

export const ProjectPriority = 
[
  { value: "NOTSPECIFIED", text: "Not Specified" },
  { value: "LOW", text: "Low" },
  { value: "MEDIUM", text: "Medium" },
  { value: "HIGH", text: "High" },
]

export const TaskStatus = 
[
  { value: "NOTSTARTED", text: "Not Started" },
  { value: "INPROGRESS", text: "In Progress" },
  { value: "ONHOLD", text: "On Hold" },
  { value: "COMPLETED", text: "Completed" },
]

//#endregion